<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ic8eTO/tc-custom/9781504039659.jpg?1728954665539" alt="This image is the cover for the book Warden, The Chronicles of Barsetshire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Warden, The Chronicles of Barsetshire
      </h1>
      <p class="bookDescription body article font2">
        <b>A well-meaning public official finds himself embroiled in a political scandal in this acclaimed satire. </b><br/><br/> Set in an almshouse in rural England, <i>The Warden</i> features the realism, satire, and biting social commentary that helped establish Anthony Trollope as one of the preeminent English novelists of his day.<br/>  <br/> Septimus Harding is the modest and wizened warden of Hiram’s Hospital, a charitable institution funded by money bequeathed to the Diocese of Barchester. When young upstart John Bold stages a campaign that challenges the use of these charitable funds—and Harding’s seemingly exorbitant earnings—critics come out of the woodwork to question the hospital’s dealings. And making matters personal, Bold is courting Harding’s daughter, Eleanor.<br/>  <br/> The first installment in the Chronicles of Barsetshire, <i>The Warden</i> illuminates perceived Christian hypocrisies, yet strikes a light-hearted tone. A clear-eyed and humane work of satire, it brilliantly examines issues just as relevant today as in Victorian England.<br/>  <br/><i>This ebook has been professionally proofread to ensure accuracy and readability on all devices.</i><br/>  <br/>  <br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony Trollope
      </h2>
      
      <p class="authorDescription body article">Anthony Trollope (1815&ndash;1882) was the author of over fifty books of fiction and nonfiction and is widely regarded as one of the preeminent English novelists of the Victorian era. Uncommon in his ability to capture both a wide readership and the highest respect of his most influential critics and peers&mdash;including luminaries such as Nathaniel Hawthorne, William Thackeray, Henry James, and George Eliot&mdash;Trollope is best remembered for two great sextets, the Chronicles of Barsetshire and the Pallisers, as well as his late-career satirical masterpiece <I>The Way We Live Now</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14cd2ad0